import React from 'react';
import {
    shape,
    func,
    string,
    arrayOf,
    bool,
    number,
    oneOfType,
    instanceOf
} from 'prop-types';

import Icon from 'components/icon';
import { Select } from '.';

const Form = ({
    serpUrl,
    buttonTitle,
    handleSubmit,
    inputMaxLength,
    inputValue,
    selectValue,
    categoryField,
    searchField,
    handleSelectChange,
    handleChange,
    handleFocus,
    handleBlur,
    isFocused,
    isQueryValid,
    inputRef
}) => {
    if (!categoryField && !searchField) {
        return null;
    }

    return (
        <form
            action={serpUrl}
            autoComplete="off"
            className="c-search__form"
            method="GET"
            onSubmit={handleSubmit}
        >
            <div className="c-search__form-body">
                <div className="c-search__form-select-container">
                    <Select
                        value={selectValue}
                        label={categoryField.label}
                        name={categoryField.id}
                        options={categoryField.options}
                        onChange={handleSelectChange}
                    />
                </div>
                <div className="c-search__form-input-container">
                    <label className="u-sr-only" htmlFor={searchField.id}>
                        {searchField && searchField.label}
                    </label>
                    <input
                        type="search"
                        placeholder={
                            isFocused
                                ? undefined
                                : searchField && searchField.placeholder
                        }
                        className="c-search__form-input"
                        id={searchField.id}
                        maxLength={inputMaxLength}
                        name={searchField.id}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={inputValue}
                        ref={inputRef}
                    />
                    <button
                        type="submit"
                        className={`c-search__form-button ${
                            isQueryValid ? 'is-active' : ''
                        }`}
                    >
                        <span className="u-sr-only">{buttonTitle}</span>
                        {isQueryValid ? (
                            <Icon glyph="arrow-right" />
                        ) : (
                            <Icon glyph="search" />
                        )}
                    </button>
                </div>
            </div>
        </form>
    );
};

Form.propTypes = {
    serpUrl: string.isRequired,
    buttonTitle: string.isRequired,
    handleSubmit: func.isRequired,
    inputMaxLength: number.isRequired,
    inputValue: string.isRequired,
    selectValue: string.isRequired,
    categoryField: shape({
        id: string,
        label: string,
        value: string,
        options: arrayOf(shape({ value: string, label: string }))
    }).isRequired,
    searchField: shape({
        id: string,
        label: string,
        value: string
    }).isRequired,
    handleSelectChange: func.isRequired,
    handleChange: func.isRequired,
    handleFocus: func.isRequired,
    handleBlur: func.isRequired,
    isFocused: bool.isRequired,
    isQueryValid: bool.isRequired,
    inputRef: oneOfType([
        func,
        shape({ current: instanceOf(HTMLInputElement) })
    ])
};

export default Form;
